class DeliveryTimer {
  constructor(element, earliest, latest) {
    this.element = element;
    this.earliest = earliest;
    this.latest = latest;
    this.cutoffTime = element.dataset.cutoffTime;
    this.timeDisplay = element.querySelector(".countdown-timer");
    this.deliveryDisplay = element.querySelector(".delivery-date__text");

    this.updateTimer();
    setInterval(() => this.updateTimer(), 1000);
  }

  updateTimer() {
    const now = new Date();
    // Convert to EST/EDT
    const estTime = new Date(
      now.toLocaleString("en-US", { timeZone: "America/New_York" })
    );
    const cutoff = new Date(estTime);
    const [hours, minutes] = this.cutoffTime.split(":");

    // Check if current day is weekend
    const isWeekend = estTime.getDay() === 0 || estTime.getDay() === 6;

    if (isWeekend) {
      // If weekend, set cutoff to next business day at cutoff time
      cutoff.setDate(cutoff.getDate() + (estTime.getDay() === 0 ? 1 : 2));
      cutoff.setHours(hours, minutes, 0);
    } else {
      // Regular weekday logic
      cutoff.setHours(hours, minutes, 0);

      if (estTime > cutoff) {
        // After cutoff - show next business day
        cutoff.setDate(cutoff.getDate() + 1);
        // Skip weekend if necessary
        while (cutoff.getDay() === 0 || cutoff.getDay() === 6) {
          cutoff.setDate(cutoff.getDate() + 1);
        }
      }
    }

    const timeLeft = cutoff - estTime;

    if (timeLeft > 0) {
      if (timeLeft < 86400000) {
        const hours = Math.floor(timeLeft / (1000 * 60 * 60));
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

        this.timeDisplay.innerHTML = `Order in <strong>${
          hours > 0 ? hours + "h" : ""
        } ${minutes > 0 ? minutes + "m" : ""} ${seconds}s</strong> get it `;
      } else {
        this.timeDisplay.innerHTML = `Order now and get it `;
      }

      // Calculate delivery dates
      let deliveryStart = new Date(cutoff);
      let businessDays = 0;

      // Add 3-4 business days
      while (businessDays < this.latest) {
        deliveryStart.setDate(deliveryStart.getDate() + 1);
        if (deliveryStart.getDay() !== 0 && deliveryStart.getDay() !== 6) {
          businessDays++;
          if (businessDays === this.earliest) {
            var earliestDate = new Date(deliveryStart);
          }
        }
      }

      const formatDate = (date) => {
        return date.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
        });
      };

      this.timeDisplay.innerHTML += `<strong>${formatDate(
        earliestDate
      )} - ${formatDate(deliveryStart)}</strong>`;
    } else {
      this.timeDisplay.innerHTML = "Order tomorrow for delivery in";
    }
  }
}
